module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "1300px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Push Campaign to Review")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "aria-label": "Close push to review modal"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('invoices-brief-confirmation', {
    attrs: {
      "viewCampaignID": _vm.viewCampaignID,
      "isView": true
    },
    on: {
      "confirmBrief": _vm.confirmBrief,
      "closeBriefModal": _vm.closeModal
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.openUpdateCampaignQuarterModal
    }
  }, [_vm._v("\n          Push to Review\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('update-campaign-quarter-modal', {
    attrs: {
      "value": _vm.campaignQuarterDialog,
      "campaignID": _vm.viewCampaignID
    },
    on: {
      "updated": _vm.confirmBrief
    },
    model: {
      value: (_vm.campaignQuarterDialog),
      callback: function($$v) {
        _vm.campaignQuarterDialog = $$v
      },
      expression: "campaignQuarterDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d08c59ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/InvoicesBriefViewModal.vue
// module id = 2292
// module chunks = 0